import React from "react";

const Promo = () => {
  return <div>Promo</div>;
};

export default Promo;
